import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

const ligne = { marginTop: 8 };

function valeurOuiNon(valeur) {
  return valeur ? 'Oui' : 'Non';
}

function progressionRunbook(v) {
  const r = v || {};
  return {
    migrationDev: Boolean(r.migrationDevEnvSet && r.migrationDevMigrationsList && r.migrationDevDbContextInfo && r.migrationDevDatabaseUpdate && r.migrationDevHistoriqueVerifie),
    publishDev: Boolean(r.publishDevPrereqCompileLocal && r.publishDevPrereqProfilsExistants && r.publishDevOuvrirSolution && r.publishDevClicDroitPublish && r.publishDevSelectionProfilDev && r.publishDevParametresVerifies && r.publishDevValidateConnection && r.publishDevSettingsVerifies && r.publishDevCliquerPublish),
    validationDev: Boolean(r.validationDevSiteCharge && r.validationDevLoginOk && r.validationDevCalendrierOk && r.validationDevAjoutPresenceOk && r.validationDevLogsSansErreurCritique && r.validationDevPasErreurSchemaSql && r.validationDevAckOutboxOk && r.validationDevStopSiKo),
    migrationProd: Boolean(r.migrationProdEnvSet && r.migrationProdMigrationsList && r.migrationProdDbContextInfo && r.migrationProdDatabaseUpdate && r.migrationProdHistoriqueVerifie),
    publishProd: Boolean(r.publishProdVerificationRapideFaite && r.publishProdClicDroitPublish && r.publishProdSelectionProfilProd && r.publishProdParametresVerifies && r.publishProdValidateConnection && r.publishProdDatabasePublishDesactive && r.publishProdCliquerPublish),
    validationProd: Boolean(r.validationProdSiteAccessible && r.validationProdLoginOk && r.validationProdFluxPrincipalOk && r.validationProdLogsSansErreurCritique && r.validationProdPasMigrationAuto && r.validationProdAckOutboxOk),
  };
}

function DeploiementResume({ rapport }) {
  if (!rapport) {
    return (
      <Paper style={{ padding: 16 }}>
        <Typography variant="body1">Aucun rapport a afficher.</Typography>
      </Paper>
    );
  }

  const referenceVersion = rapport.referenceVersion || {};
  const validationsPlesk = rapport.validationsPlesk || {};
  const validationsBaseDonnees = rapport.validationsBaseDonnees || {};
  const validationsRunbook = rapport.validationsRunbook || {};
  const validationsPostDeploiement = rapport.validationsPostDeploiement || {};
  const progression = progressionRunbook(validationsRunbook);

  return (
    <Paper style={{ padding: 16 }}>
      <Typography variant="h6">Apercu avant validation</Typography>
      <Divider style={{ marginTop: 12, marginBottom: 12 }} />

      <Typography style={ligne}><strong>Environnement:</strong> {rapport.environnementCible}</Typography>
      <Typography style={ligne}><strong>Operateur:</strong> {rapport.operateur}</Typography>
      <Typography style={ligne}><strong>Branche:</strong> {referenceVersion.branche || 'N/A'}</Typography>
      <Typography style={ligne}><strong>Commit:</strong> {referenceVersion.commit || 'N/A'}</Typography>
      <Typography style={ligne}><strong>Version:</strong> {referenceVersion.version || 'N/A'}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography variant="subtitle1">Validation Plesk</Typography>
      <Typography style={ligne}>Site actif: {valeurOuiNon(validationsPlesk.siteActif)}</Typography>
      <Typography style={ligne}>Espace disque suffisant: {valeurOuiNon(validationsPlesk.espaceDisqueSuffisant)}</Typography>
      <Typography style={ligne}>Connexion DB OK: {valeurOuiNon(validationsPlesk.connexionDbOk)}</Typography>
      <Typography style={ligne}>SSL valide: {valeurOuiNon(validationsPlesk.sslValide)}</Typography>
      <Typography style={ligne}>Variables environnement valides: {valeurOuiNon(validationsPlesk.variablesEnvironnementOk)}</Typography>
      <Typography style={ligne}>Isolation racines web: {valeurOuiNon(validationsPlesk.isolationRacinesOk)}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography variant="subtitle1">Validation DB / migration / rollback</Typography>
      <Typography style={ligne}>Migration necessaire: {validationsBaseDonnees.migrationNecessaire}</Typography>
      <Typography style={ligne}>Migration sensible: {valeurOuiNon(validationsBaseDonnees.migrationSensible)}</Typography>
      <Typography style={ligne}>Migration validee: {valeurOuiNon(validationsBaseDonnees.migrationValidee)}</Typography>
      <Typography style={ligne}>Rollback prepare: {valeurOuiNon(validationsBaseDonnees.rollbackPrepare)}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography variant="subtitle1">Validation runbook migration + Publish</Typography>
      <Typography style={ligne}>1/6 Migration DEV: {valeurOuiNon(progression.migrationDev)}</Typography>
      <Typography style={ligne}>2/6 Publish DEV: {valeurOuiNon(progression.publishDev)}</Typography>
      <Typography style={ligne}>3/6 Validation DEV: {valeurOuiNon(progression.validationDev)}</Typography>
      <Typography style={ligne}>4/6 Migration PROD: {valeurOuiNon(progression.migrationProd)}</Typography>
      <Typography style={ligne}>5/6 Publish PROD: {valeurOuiNon(progression.publishProd)}</Typography>
      <Typography style={ligne}>6/6 Validation PROD: {valeurOuiNon(progression.validationProd)}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography variant="subtitle1">Validation post-deploiement</Typography>
      <Typography style={ligne}>Navigation de base: {valeurOuiNon(validationsPostDeploiement.navigationBaseOk)}</Typography>
      <Typography style={ligne}>Connexion utilisateur: {valeurOuiNon(validationsPostDeploiement.connexionUtilisateurOk)}</Typography>
      <Typography style={ligne}>Parcours presence: {valeurOuiNon(validationsPostDeploiement.parcoursPresenceOk)}</Typography>
      <Typography style={ligne}>ACK synchronisation: {valeurOuiNon(validationsPostDeploiement.ackSyncOk)}</Typography>
      <Typography style={ligne}>Logs sans erreur critique: {valeurOuiNon(validationsPostDeploiement.logsSansErreurCritique)}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography style={ligne}><strong>Decision finale:</strong> {rapport.decisionFinale}</Typography>
      <Typography style={ligne}><strong>Commentaire decision:</strong> {rapport.commentaireDecision || 'Aucun'}</Typography>
      <Typography style={ligne}><strong>Incidents:</strong> {rapport.incidents || 'Aucun'}</Typography>
    </Paper>
  );
}

export default DeploiementResume;



// WEBPACK FOOTER //
// src/components/deploiements/DeploiementResume.js